import { z } from 'zod';

import { PaymentDueId } from '../BrandedIds';
import { FeeLineItemInput } from '../events';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const CreateFeeSideEffectContext = BaseLoanIdSideEffect.extend({
  paymentDueId: PaymentDueId.optional(),
  lineItems: z.array(FeeLineItemInput),
  isDeferred: z.boolean(),
  comment: z.string(),
});
export const CreateFeeSideEffect = CreateFeeSideEffectContext.extend({
  type: z.literal('createFee'),
});
export type CreateFeeSideEffect = z.infer<typeof CreateFeeSideEffect>;
